module.exports = __webpack_public_path__ + "media/images/new-ui-images/patient-pic-2f833d7fcf86639ea9aa02e8b2b890a5.png";